export default theme => ({
  select: {},

  formControl: {
    height: 48,
  },
});
